import { useLocalStorage } from 'usehooks-ts';
import { useTailwindBreakpoint } from '../../hooks/useTailwindBreakpoint';
import { cn } from '../../lib/classNameHelpers';
import { localStorageKeys } from '../../lib/localstorageKeys';
import {
  BottomSheetBackdrop,
  BottomSheetContent,
  BottomSheetPortal,
  BottomSheetRoot,
  BottomSheetTitle,
  BottomSheetView,
} from '../BottomSheet/BottomSheet';
import { Button } from '../catalyst-ui-kit/button';

/**
 * Displays a warning to mobile users that the application is optimized for desktop.
 * Provides an option to continue using the mobile version.
 */
export const MobileOverlay = () => {
  const [ignoreMobileOverlay, setIgnoreMobileOverlay] = useLocalStorage(
    localStorageKeys.dismissMobileWarning,
    false
  );
  const isLg = useTailwindBreakpoint('lg');

  const handleDismiss = () => {
    setIgnoreMobileOverlay(true);
  };

  // Don't show on desktop or if user has dismissed
  if (isLg || ignoreMobileOverlay) return null;

  // Custom non-dismissible sheet for mobile
  return (
    <BottomSheetRoot
      presented={true}
      onPresentedChange={() => {
        // Ignore all dismiss attempts
      }}
    >
      <BottomSheetPortal>
        <BottomSheetView
          className="z-[60]"
          swipeDismissal={false}
          onClickOutside={{ dismiss: false }}
          inertOutside={false}
        >
          <BottomSheetBackdrop />
          <BottomSheetContent className={cn('grid max-w-[700px] justify-items-center p-4')}>
            <div className="flex w-full items-center justify-between pb-4">
              <BottomSheetTitle className="font-medium text-contentPrimary">
                Desktop Experience Recommended
              </BottomSheetTitle>
            </div>
            <div className="flex w-full flex-col gap-5">
              <p className="text-xs text-contentSecondary">
                Mobile is still under development. For the best experience with all features and
                functionality, please use our desktop application instead.
              </p>

              <Button className="w-full" color="blue" onClick={handleDismiss}>
                Continue Anyway
              </Button>
            </div>
          </BottomSheetContent>
        </BottomSheetView>
      </BottomSheetPortal>
    </BottomSheetRoot>
  );
};
